/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {ConfirmRegistration, LogOut} from '../../../actions/auth/actions-auth';

import DivLoader from '../../../components/DivLoader';
import Translate from '../../../components/Translate';

class RegistrationConfirmTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: ''
    }
  }

  componentWillMount() {

    this.props.LogOut();
  }

  componentDidMount() {

    this.setState({
      code: this.props.ack
    });

    this.props.ConfirmRegistration(this.props.ack);
  }

  componentWillReceiveProps(newProps) {

    if (!newProps.inProgress && newProps.isSuccess) {

      window.location.hash = '';
    }
  }

  render() {

    if (this.props.inProgress) {

      return (<div className="settings-col relative" style={{height: '176px', width: '80%'}}>
        <DivLoader loading={true} />
      </div>);
    }

    if (this.props.isSuccess) {
      return (<div className="register-inform">
        <p className="mt"><Translate content="settings.tabs.registration_confirm.success" /></p>
      </div>);
    }

    if (this.props.isError) {
      return (<div className="register-inform">
        <p>
          <Translate content={`error.${this.props.errorMsg}`} />
        </p>
      </div>);
    }

    return <div className="settings-col"></div>;
  }
}

RegistrationConfirmTab.propTypes = {
  inProgress: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string,
  ack: PropTypes.string
};

const mapStateToProps = ({auth: {registration_ack: {inProgress, isSuccess, isError, errorMsg}}}) => {
  return {inProgress, isSuccess, isError, errorMsg};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ConfirmRegistration, LogOut}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationConfirmTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/registration-confirm.js